import { render, staticRenderFns } from "./Composite.vue?vue&type=template&id=0e65a464&scoped=true&"
import script from "./Composite.vue?vue&type=script&lang=js&"
export * from "./Composite.vue?vue&type=script&lang=js&"
import style0 from "./Composite.vue?vue&type=style&index=0&id=0e65a464&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e65a464",
  null
  
)

export default component.exports